(function () {

// SELECTORS
  const selectors = {
    sidebarSection: '.custom-sidecart-section',
    sidebarContainer: '.custom-sidecart',
    sidebarQty: 'sidecart-qty',
    headerCartButton: '.site-header-cart--button',
    closeSidebarElement: '[data-close-sidebar]',
    orderNoteBlock: '.custom-sidecart-ordernote',
    orderNoteOpen: '.custom-sidecart__ordernote-open',
    orderNoteClose: '[data-close-ordernote]',
    orderNoteSave:'[data-save-ordernote]',
    addToSidecart: 'data-add-to-sidecart',
    formError: '.product-form-error',
    removeProduct: 'data-remove-item',
    qtyInput: '[data-quantity-input]',
    customizeBtn: 'data-add-customize-to-sidecart'
  };


// GET SCROLLBAR WIDTH
  let scrollbarWidth = window.innerWidth - document.body.offsetWidth;
  window.addEventListener('resize', () => {
    scrollbarWidth = window.innerWidth - document.body.offsetWidth;
  }, true);


// OPEN SIDECART
  const openSidebar = (e) => {
    if (e) {
      e.preventDefault();
    }
    document.querySelector('body').classList.add('sidebar-opened');
    document.querySelector(selectors.sidebarSection).classList.add('is-open');
    document.querySelector('html').style.paddingRight = scrollbarWidth + 'px';
  }


// CLOSE SIDECART
  const closeSidebar = (e) => {
    e.preventDefault();
    document.querySelector('body').classList.remove('sidebar-opened');
    document.querySelector(selectors.sidebarSection).classList.remove('is-open');
    document.querySelector('html').style.paddingRight = 0;
  }


// SHOW ERROR
  const showError = (el, desc) => {
    const errorWrapper = el.closest('div');
    const productFormError = document.querySelector(selectors.formError);
    if (errorWrapper && !productFormError) {
      const formError = document.createElement('p');
      formError.classList.add('product-form-error');
      formError.innerHTML = desc;
      errorWrapper.insertAdjacentElement('afterend', formError);
    } else {
      productFormError.innerHTML = desc;
    }
  }


// SHOW/HIDE PRODUCT OVERLAY
  const productOverlay = (item, status) => {
    if (status) {
      item.classList.add('is-loading');
    } else {
      item.classList.remove('is-loading');
    }
  }


// CHANGE QTY
  const checkQty = (eventType, thisInput) => {{
    if (thisInput.classList.contains('sidecart-item-qty__input')) {
      if (thisInput.value.match(/[^0-9]/g)) {
        thisInput.value = thisInput.value.replace(/[^0-9]/g, '');
      }

      if (thisInput.value > 1 && thisInput.value >= Number(thisInput.getAttribute('data-max-qty'))) {
        thisInput.value = Number(thisInput.getAttribute('data-max-qty'));
        thisInput.previousElementSibling.removeAttribute('disabled');
        thisInput.nextElementSibling.setAttribute('disabled', 'disabled');
      } else if (thisInput.value > 1 && thisInput.value !== Number(thisInput.getAttribute('data-max-qty'))) {
        thisInput.previousElementSibling.removeAttribute('disabled');
        thisInput.nextElementSibling.removeAttribute('disabled');
      } else if (thisInput.value === 1 && Number(thisInput.getAttribute('data-max-qty')) === 1) {
        thisInput.previousElementSibling.setAttribute('disabled', 'disabled');
        thisInput.nextElementSibling.setAttribute('disabled', 'disabled');
      } else {
        thisInput.previousElementSibling.setAttribute('disabled', 'disabled');
        thisInput.nextElementSibling.removeAttribute('disabled');
      }

      if (eventType === 'change') {
        if (thisInput.value < 1) {
          thisInput.value = 1;
        }
        setTimeout(() => {
          updateProduct(thisInput.closest('.sidecart-item'));
        }, 300);
      }
    }
  }}

  document.addEventListener('input', (e) => {checkQty('input', e.target)});
  document.addEventListener('change', (e) => {checkQty('change', e.target)});

  document.addEventListener('rebuy:cart.add', function(event){
    updateProductRebuy(event.detail);
  });

  document.addEventListener('click', (e) => {
    if (e.target.classList.contains('sidecart-item-qty__btn')) {
      const thisInput = e.target.closest('.sidecart-item-qty').querySelector(selectors.qtyInput);
      if (e.target.hasAttribute('data-quantity-minus')) {
        thisInput.value = --thisInput.value;
      } else if (e.target.hasAttribute('data-quantity-plus')) {
        thisInput.value = ++thisInput.value;
      }
      thisInput.dispatchEvent(new Event('change', { 'bubbles': true }));
    }
  });


// ADD PRODUCT
  const addProduct = (event) => {
    const thisBtn = event;
    const thisForm = event.closest('[data-product-form]')
    const productFormError = document.querySelector(selectors.formError);
    let config;

    thisBtn.classList.add('processing');

    if (productFormError) {
      productFormError.remove();
    }

    if (thisForm) {
      config = {
        method: 'POST',
        headers: {
          'Accept': `application/javascript`,
          'X-Requested-With': 'XMLHttpRequest'
        }
      };

      const formData = new FormData(thisForm);
      formData.append('sections', getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
    } else if (thisBtn.hasAttribute('data-variant-id')) {
      const productId = thisBtn.getAttribute('data-variant-id');
      config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = 'application/json';
      config.body = JSON.stringify({
        id: productId,
        quantity: 1,
        sections: getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      });
    }

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status === 422) {
          showError(thisBtn, response.description);
          return;
        }
        renderContents(response, true);
        openSidebar();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        thisBtn.classList.remove('processing');
        if (document.querySelector('body').classList.contains('modal-visible')
          && event.closest('[data-modal-container]')
          && document.querySelector('.allow-scroll-while-locked .modal-close')) {
          document.querySelector('.allow-scroll-while-locked .modal-close').click();
        }
      });
  }

  const addCustomizeProduct = () => {
    const inputsList = document.querySelectorAll('[data-location-block]');
    const thisBtn = document.querySelector('[data-add-customize-to-sidecart]');
    let validate = true;
    let config;
    const formValues = [];
    inputsList.forEach(function (item) {
      if (item.querySelector('.js-park-name')) {
        if (!item.querySelector('.js-park-name').value.length) {
          item.querySelector('.product-loc__input-wrapper').classList.add('is-error');
          validate = false;
        }
      }
      if (item.querySelector('.js-location-input')) {
        if (!item.querySelector('.js-location-input').value.length > 0) {
          item.querySelector('.js-location-input').closest('.product-loc__input-wrapper').classList.add('is-error');
          validate = false;
        }
      }
      if (item.querySelector('.js-date-input')) {
        if (!item.querySelector('.js-date-input').value.length) {
          item.querySelector('.js-date-required').style.display = 'block';
          item.querySelector('.js-date-input').closest('.product-loc__input-wrapper').classList.add('is-error');
          validate = false;
        } else {
          const validateDate = checkDateFormat(item.querySelector('.js-input').value);
          if (validateDate) {
            item.querySelector('.js-product-loc-error').style.display = 'none';
            item.querySelector('.js-date-input').closest('.product-loc__input-wrapper').classList.remove('is-error');
          } else {
            item.querySelector('.js-product-loc-error').style.display = 'block';
            item.querySelector('.js-date-input').closest('.product-loc__input-wrapper').classList.add('is-error');
          }
        }
      }
    })
    if (validate) {
      thisBtn.classList.add('processing');
      const formData = {
        'items': []
      };
      document.querySelectorAll('.js-properties-input').forEach(function (element) {
        const productId = element.getAttribute('data-product-id');
        formData.items.push({
          id: productId,
          quantity: 1,
          properties: {
            Location: element.value,
            '_image': element.getAttribute('data-property-image'),
            '_order-image': `${element.getAttribute('data-property-image')}&token=${element.getAttribute('data-key')}`
          }
        })
      })
      formData.items.reverse();
      formData.sections = getSectionsToRender().map((section) => section.id);
      formData.sections_url = window.location.pathname;
      addItemToCart();

      function addItemToCart() {
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status === 422) {
              showError(thisBtn, response.description);
              return;
            }
            renderContents(response, true);
            openSidebar();
            document.querySelectorAll('[data-location-block]').forEach(function (item, index) {
              if (index > 0) {
                item.remove();
              }
            })
            document.querySelector('.js-park-name').value = '';
            document.querySelector('.js-park-name').dispatchEvent(new Event('change'));
            document.querySelector('.js-location-input').value = '';
            document.querySelector('.js-location-input').dispatchEvent(new Event('click'));
            document.querySelector('.js-location-input').dispatchEvent(new Event('blur'));
            document.querySelector('.hasDatepicker').value = '';
            document.querySelector('.hasDatepicker').dispatchEvent(new Event('click'));
            document.querySelector('.hasDatepicker').dispatchEvent(new Event('blur'));
            document.querySelector('[data-location-add]').style.display = 'block';
            document.querySelector('[data-location-remove]').style.display = 'none'
            thisBtn.classList.remove('processing');
            document.querySelector('.product-gallery--viewer').style.display = 'block';
            document.querySelectorAll('.product-gallery_stamp').forEach((el) => {
              el.remove();
            })
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (document.querySelector('body').classList.contains('modal-visible')
              && event.closest('[data-modal-container]')
              && document.querySelector('.allow-scroll-while-locked .modal-close')) {
              document.querySelector('.allow-scroll-while-locked .modal-close').click();
            }
          });
      }
    }
  }

  const checkDateFormat = (dateValue) => {
    const pattern = /^\d{2}\/\d{2}\/\d{4}$/;
    let dateValid = true;

    const parts = dateValue.split('/');
    const month = parseInt(parts[0], 10);
    const day = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);

    const now = new Date();
    const currentYear = now.getFullYear();

    dateValid = dateValue.length > 0 && pattern.test(dateValue);

    if (month < 1 || month > 12) {
      dateValid = false
    }

    if (day < 1 || day > 31) {
      dateValid = false
    }
    if (year < 1000 || year > currentYear) {
      dateValid = false
    }
    return dateValid
  }

  const saveNote = (text) => {
    const config = {
      method: 'POST',
      headers: {
        'Accept': `application/json`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({'note': text})
    };
    fetch(`/cart/update.js`, config)
      .then((response) => response.json())
      .then((response) => {
        document.querySelector(selectors.sidebarContainer).classList.remove('order-note-opened');
      })
      .catch((e) => {
        console.error(e);
      });
  }

// UPDATE PRODUCT
  const updateProduct = (event) => {
    const productLine = event.getAttribute('data-line-item');
    const productQty = event.querySelector(selectors.qtyInput).value;

    const config = fetchConfig('javascript');
    config.body = JSON.stringify({
      line: productLine,
      quantity: productQty,
      sections: getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    productOverlay(event, true);

    fetch(`${routes.cart_change_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        renderContents(response);
        productOverlay(event);
      })
      .catch((e) => {
        console.error(e);
      });
  }


// REMOVE PRODUCT
  const removeProduct = (event) => {
    const productLine = event.getAttribute('data-line-item');

    productOverlay(event, true);

    const config = fetchConfig('javascript');
    config.body = JSON.stringify({
      line: productLine,
      quantity: 0,
      sections: getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        renderContents(response, true);
        if(response.item_count === 0) {
          saveNote('');
        }
      })
      .catch((e) => {
        console.error(e);
      });

  }

  const updateProductRebuy = (detail) => {
    const productId = detail.item.key;
    const productQty = detail.item.quantity;

    const config = fetchConfig('javascript');
    config.body = JSON.stringify({
      id: productId,
      quantity: productQty,
      sections: getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      });
  }


// RENDER CONTENTS
  const fetchConfig = (type = 'json') => {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }

  const renderContents = (parsedState, event = false) => {
    getSectionsToRender().forEach((section => {
      section.selector.forEach((selector) => {
        if (selector !== '#sidecart-related') {
          document.querySelector(selector).innerHTML = getSectionInnerHTML(parsedState.sections[section.id], selector);
        }
        if (selector === '#sidecart-related' && event === true) {
          document.querySelector(selector).innerHTML = getSectionInnerHTML(parsedState.sections[section.id], selector);
        }
      })
    }));

    if (parsedState.item_count === 0 && document.querySelector('.custom-sidecart__related-product')) {
      document.querySelector('.custom-sidecart__related-product').remove();
    }

    const sidecartFooter = document.getElementById('sidecart-footer');
    if (parsedState.item_count === 0) {
      sidecartFooter.classList.add('is-empty');
    } else {
      sidecartFooter.classList.remove('is-empty');
    }
  }

  const getSectionsToRender = () => {
    return [
      {
        id: 'custom-sidecart',
        selector: ['#sidecart-products', '#sidecart-free-shipping', '#sidecart-total-value', '#sidecart-title', '#sidecart-related']
      },
      {
        id: 'static-header',
        selector: ['.site-header-cart--button']
      }
    ];
  }

  const getSectionInnerHTML = (html, selector = '.shopify-section') => {
    let doc = new DOMParser().parseFromString(html, 'text/html');
    if (!doc.querySelector(selector)) {
      return '';
    }
    return doc.querySelector(selector).innerHTML;
  }


// INIT SLIDER
  const relatedProductsInit = () => {
    const relatedSlider = new Swiper('.cart-also-like', {
      slidesPerView: 1,
      spaceBetween: 10,
      autoHeight: true,
      navigation: {
        prevEl: ".custom-sidecart__slider-nav-prev",
        nextEl: ".custom-sidecart__slider-nav-next",
      },
    })
  }


// PRODUCT RECOMMENDATIONS
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            // init "You May Also Like" slider
            relatedProductsInit();
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this)).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);


// CLICK EVENTS
  window.addEventListener('DOMContentLoaded', () => {

    // open sidecart
    const cartBtn = document.querySelector(selectors.headerCartButton);
    if (cartBtn) {
      cartBtn.addEventListener('click', (e) => {
        openSidebar(e);
      })
    }

    // close sidecart
    const closeEl = document.querySelectorAll(selectors.closeSidebarElement);
    if (closeEl !== undefined) {
      closeEl.forEach((el) => {
        el.addEventListener('click', (e) => {
          closeSidebar(e);
        })
      })
    }

    // open/close order note
    const orderNoteBtns = document.querySelectorAll([selectors.orderNoteOpen, selectors.orderNoteClose]);
    if (orderNoteBtns) {
      orderNoteBtns.forEach((el) => {
        el.addEventListener('click', (e) => {
          document.querySelector(selectors.sidebarContainer).classList.toggle('order-note-opened');
        })
      })
    }

    //save order note
    const orderNoteSaveBtns = document.querySelectorAll(selectors.orderNoteSave);
    if (orderNoteSaveBtns) {
      orderNoteSaveBtns.forEach((el) => {
        el.addEventListener('click', (e) => {
          const noteText = document.getElementById('cart-note').value;
          saveNote(noteText);
        })
      })
    }

    document.addEventListener('click', (e) => {
      // add product to cart
      if (e.target.hasAttribute(selectors.addToSidecart) || (e.target.closest('button') && e.target.closest('button').hasAttribute(selectors.addToSidecart))) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        addProduct(e.target.hasAttribute(selectors.addToSidecart) ? e.target : e.target.closest('button'));
      }
      if (e.target.hasAttribute(selectors.customizeBtn) || (e.target.closest('button') && e.target.closest('button').hasAttribute(selectors.customizeBtn))) {

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        addCustomizeProduct();
      }

      // remove product
      if (e.target.hasAttribute(selectors.removeProduct) || (e.target.closest('button') && e.target.closest('button').hasAttribute(selectors.removeProduct))) {
        removeProduct(e.target.closest('.sidecart-item'));
      }
    })
  });

  window.addEventListener("load", function (event) {
    setTimeout(function () {
      if (document.querySelector('.swym-add-to-cart-btn')) {
        document.querySelectorAll('.swym-add-to-cart-btn').forEach(function (element) {
          element.addEventListener('click', function (e) {
            setTimeout(function () {
              fetch('/cart.js')
                .then(response => response.json())
                .then(text => {
                  let dataObj = {};
                  const config = fetchConfig('javascript');
                  config.body = JSON.stringify({
                    id: text.items[0].key,
                    quantity: text.items[0].quantity,
                    sections: getSectionsToRender().map((section) => section.id),
                    sections_url: window.location.pathname,
                  });

                  fetch(`${routes.cart_change_url}`, config)
                    .then((response) => response.json())
                    .then((response) => {
                      renderContents(response, true);
                      openSidebar(e);
                    })
                    .catch((e) => {
                      console.error(e);
                    });

                })
            }, 600)
          })
        })
      }
    }, 3000)
  })
})();

document.addEventListener("DOMContentLoaded", function () {
  function updateSubscriptionLabels() {
    // 1. Update "Deliver every month" to "Recurring Monthly Donation"
    const planLabels = document.querySelectorAll('.shopify_subscriptions_app_block_label_children label');
    planLabels.forEach(label => {
      label.childNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.includes("Deliver every month")) {
          node.textContent = " Recurring Monthly Donation";
        }
      });
    });

    // 2. Update "One-time purchase" to "One-time Donation"
    const allLabels = document.querySelectorAll('label');
    allLabels.forEach(label => {
      label.childNodes.forEach(node => {
        if (
          node.nodeType === Node.TEXT_NODE &&
          node.textContent.trim() === "One-time purchase"
        ) {
          node.textContent = " One-time Donation";
        }
      });
    });
  }

  // Run once on load
  updateSubscriptionLabels();

  // Use MutationObserver to handle dynamic loading
  const observer = new MutationObserver(updateSubscriptionLabels);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
